module.exports = __webpack_public_path__ + "img/interaction-bar-cjdr.c8086bad.png";